// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file copilot_sessions/v1/agent_merge.proto (package github.copilot_sessions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file copilot_sessions/v1/agent_merge.proto.
 */
export const file_copilot_sessions_v1_agent_merge: GenFile = /*@__PURE__*/
  fileDesc("CiVjb3BpbG90X3Nlc3Npb25zL3YxL2FnZW50X21lcmdlLnByb3RvEhpnaXRodWIuY29waWxvdF9zZXNzaW9ucy52MSJxCg9BZ2VudE1lcmdlU2NvcGUSEQoJbmFtZXNwYWNlGAEgASgJEhUKDXJlcG9zaXRvcnlfaWQYAiABKAMSGwoTcHVsbF9yZXF1ZXN0X251bWJlchgDIAEoAxIXCg9wdWxsX3JlcXVlc3RfaWQYBCABKAMi2AIKEUFnZW50TWVyZ2VDb250ZXh0EjoKBXNjb3BlGAEgASgLMisuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVNjb3BlEg8KB2VuYWJsZWQYAiABKAgSPgoYY29uZmlndXJhdGlvbl9nZW5lcmF0aW9uGAMgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlVJbnQ2NFZhbHVlEhAKCGhlYWRfb2lkGAQgASgJElUKD2Rpc2FibGVkX3JlYXNvbhgFIAEoDjI8LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VDb250ZXh0LkRpc2FibGVkUmVhc29uIk0KDkRpc2FibGVkUmVhc29uEhgKFERJU0FCTEVEX1JFQVNPTl9OT05FEAASIQodRElTQUJMRURfUkVBU09OX0FUVEVNUFRfTElNSVQQASK1AwoRQWdlbnRNZXJnZVNlc3Npb24SDgoGam9iX2lkGAEgASgJEhIKCnNlc3Npb25faWQYAiABKAkSDAoEZ29hbBgDIAEoCRILCgN1cmwYBCABKAkSRAoGc3RhdHVzGAUgASgOMjQuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVNlc3Npb24uU3RhdHVzElcKEGxpZmVjeWNsZV9zb3VyY2UYBiABKA4yPS5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlU2Vzc2lvbi5MaWZlY3ljbGVTb3VyY2UilAEKBlN0YXR1cxILCgdVTktOT1dOEAASCwoHUEVORElORxABEgoKBlFVRVVFRBACEgsKB1JVTk5JTkcQAxINCglDT01QTEVURUQQBBIKCgZGQUlMRUQQBRINCglDQU5DRUxMRUQQBhINCglUSU1FRF9PVVQQBxIUChBXQUlUSU5HX0ZPUl9VU0VSEAgSCAoESURMRRAJIisKD0xpZmVjeWNsZVNvdXJjZRIHCgNKT0IQABIPCgtBSFBfU0VTU0lPThABIrIEChhBZ2VudE1lcmdlU3RhdHVzUmVzcG9uc2USPgoHY29udGV4dBgBIAEoCzItLmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VDb250ZXh0ElEKCXNlbGVjdGlvbhgCIAEoDjI+LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VTdGF0dXNSZXNwb25zZS5TZWxlY3Rpb24SRwoQc2VsZWN0ZWRfc2Vzc2lvbhgDIAEoCzItLmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VTZXNzaW9uEhgKEGFjdGl2aXR5X2NoYW5uZWwYBCABKAkSGAoQdGVybWluYWxfam9iX2lkcxgFIAMoCRJRChFldmFsdWF0aW9uX3N0YXR1cxgGIAEoCzI2LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VFdmFsdWF0aW9uU3RhdHVzEiEKGWV2YWx1YXRpb25fc3RhdHVzX2NoYW5uZWwYByABKAkSTQoPcmVzb2x2ZWRfc3RhdHVzGAggASgLMjQuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVJlc29sdmVkU3RhdHVzIkEKCVNlbGVjdGlvbhILCgdVTktOT1dOEAASCAoETk9ORRABEgwKCFNFTEVDVEVEEAISDwoLVU5BVkFJTEFCTEUQAyLXAQoWQWdlbnRNZXJnZVByZXNlbnRhdGlvbhJFCgRraW5kGAEgASgOMjcuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVByZXNlbnRhdGlvbi5LaW5kEgwKBGNvZGUYAiABKAkSDwoHbWVzc2FnZRgDIAEoCSJXCgRLaW5kEhAKDEtJTkRfVU5LTk9XThAAEgsKB05FVVRSQUwQARILCgdTVUNDRVNTEAISCwoHV0FSTklORxADEgwKCENSSVRJQ0FMEAQSCAoEQlVTWRAFIowCChlBZ2VudE1lcmdlRXZhbHVhdGlvblNjb3BlEjoKBXNjb3BlGAEgASgLMisuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVNjb3BlEhsKE3JlcG9zaXRvcnlfb3duZXJfaWQYAiABKAkSHQoVcmVwb3NpdG9yeV9vd25lcl90eXBlGAMgASgJEhUKDW93bmVyX3VzZXJfaWQYBCABKAkSIAoYY29uZmlndXJhdGlvbl9nZW5lcmF0aW9uGAUgASgJEhAKCGhlYWRfb2lkGAYgASgJEhAKCGJhc2Vfb2lkGAcgASgJEhoKEmRpc3BsYXlfZ2VuZXJhdGlvbhgIIAEoCSKFAwoYQWdlbnRNZXJnZVJlc29sdmVkU3RhdHVzEg8KB3Zpc2libGUYASABKAgSRAoFc2NvcGUYAyABKAsyNS5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlRXZhbHVhdGlvblNjb3BlEkgKDHByZXNlbnRhdGlvbhgHIAEoCzIyLmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VQcmVzZW50YXRpb24SRgoHc2Vzc2lvbhgJIAEoCzI1LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VSZXNvbHZlZFNlc3Npb24SLgoKZXhwaXJlc19hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASUAoUZXhwaXJlZF9wcmVzZW50YXRpb24YCyABKAsyMi5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlUHJlc2VudGF0aW9uIloKGUFnZW50TWVyZ2VSZXNvbHZlZFNlc3Npb24SDgoGam9iX2lkGAEgASgJEhIKCnNlc3Npb25faWQYAiABKAkSDAoEZ29hbBgDIAEoCRILCgN1cmwYBCABKAkiiAMKHEFnZW50TWVyZ2VFdmFsdWF0aW9uU25hcHNob3QSEAoIcmV2aXNpb24YASABKAkSGwoTZXZhbHVhdGlvbl9yZXZpc2lvbhgCIAEoCRIVCg1ldmFsdWF0aW9uX2lkGAMgASgJEg8KB2F0dGVtcHQYBCABKA0STQoFcGhhc2UYBSABKA4yPi5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlRXZhbHVhdGlvblNuYXBzaG90LlBoYXNlEi8KC29ic2VydmVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgpleHBpcmVzX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJhCgVQaGFzZRIRCg1QSEFTRV9VTktOT1dOEAASCgoGUVVFVUVEEAESDgoKRVZBTFVBVElORxACEg0KCVBSRVBBUklORxADEgwKCERFRkVSUkVEEAQSDAoIRklOSVNIRUQQBSKCBAoaQWdlbnRNZXJnZUV2YWx1YXRpb25TdGF0dXMSWQoMYXZhaWxhYmlsaXR5GAEgASgOMkMuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZUV2YWx1YXRpb25TdGF0dXMuQXZhaWxhYmlsaXR5EkQKBXNjb3BlGAIgASgLMjUuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZUV2YWx1YXRpb25TY29wZRIQCghyZXZpc2lvbhgDIAEoCRJKCghzbmFwc2hvdBgEIAEoCzI4LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VFdmFsdWF0aW9uU25hcHNob3QSSAoMcHJlc2VudGF0aW9uGAUgASgLMjIuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVByZXNlbnRhdGlvbhJRChVmYWxsYmFja19wcmVzZW50YXRpb24YBiABKAsyMi5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlUHJlc2VudGF0aW9uIkgKDEF2YWlsYWJpbGl0eRIYChRBVkFJTEFCSUxJVFlfVU5LTk9XThAAEg0KCUFWQUlMQUJMRRABEg8KC1VOQVZBSUxBQkxFEAIi5BEKEkFnZW50TWVyZ2VBY3Rpdml0eRIXCg90cmFuc3BvcnRfc2NvcGUYASABKAkSFQoNZXZhbHVhdGlvbl9pZBgCIAEoCRIPCgdhdHRlbXB0GAMgASgFEhUKDXRyYW5zaXRpb25faWQYBCABKAkSQwoFcGhhc2UYBSABKA4yNC5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlQWN0aXZpdHkuUGhhc2USRwoHb3V0Y29tZRgGIAEoDjI2LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VBY3Rpdml0eS5PdXRjb21lEkUKBnJlYXNvbhgHIAEoDjI1LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VBY3Rpdml0eS5SZWFzb24SLwoLb2NjdXJyZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCmV4cGlyZXNfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDHRyaWdnZXJlZF9hdBgKIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIcmV0cnlfYXQYCyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEkYKIWFkdmlzb3J5X2NvbmZpZ3VyYXRpb25fZ2VuZXJhdGlvbhgMIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQ2NFZhbHVlEkUKIGN1cnJlbnRfY29uZmlndXJhdGlvbl9nZW5lcmF0aW9uGA0gASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDY0VmFsdWUSLgoIaGVhZF9vaWQYDiABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSLgoIYmFzZV9vaWQYDyABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSLAoGam9iX2lkGBAgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEjAKCnNlc3Npb25faWQYESABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSMwoNYXNzaWdubWVudF9pZBgSIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRJRChJhdXRob3JpemVkX2FjdGlvbnMYEyADKA4yNS5naXRodWIuY29waWxvdF9zZXNzaW9ucy52MS5BZ2VudE1lcmdlQWN0aXZpdHkuQWN0aW9uEjkKE3N0ZWVyaW5nX2NvbW1hbmRfaWQYFCABKAsyHC5nb29nbGUucHJvdG9idWYuU3RyaW5nVmFsdWUSUQoNZGVsdGFfcmVhc29ucxgVIAMoDjI6LmdpdGh1Yi5jb3BpbG90X3Nlc3Npb25zLnYxLkFnZW50TWVyZ2VBY3Rpdml0eS5EZWx0YVJlYXNvbhJMCg1kZWx0YV9hY3Rpb25zGBYgAygOMjUuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZUFjdGl2aXR5LkFjdGlvbiKWAQoFUGhhc2USEQoNUEhBU0VfVU5LTk9XThAAEhUKEUVWQUxVQVRJT05fUVVFVUVEEAESDgoKRVZBTFVBVElORxACEhUKEVBSRVBBUklOR19TRVNTSU9OEAMSDAoIREVGRVJSRUQQBBIXChNFVkFMVUFUSU9OX0ZJTklTSEVEEAUSFQoRU1RFRVJJTkdfQUNDRVBURUQQBiKQAQoHT3V0Y29tZRITCg9PVVRDT01FX1VOS05PV04QABINCglOT19BQ1RJT04QARILCgdXQUlUSU5HEAISCwoHQkxPQ0tFRBADEg8KC0pPQl9DUkVBVEVEEAQSDgoKSk9CX1JFVVNFRBAFEgsKB1NURUVSRUQQBhIKCgZGQUlMRUQQBxINCglDQU5DRUxMRUQQCCKzBAoGUmVhc29uEhIKDlJFQVNPTl9VTktOT1dOEAASGQoVUkVBU09OX0NIRUNLU19QRU5ESU5HEAESHwobUkVBU09OX01FUkdFQUJJTElUWV9QRU5ESU5HEAISHQoZUkVBU09OX1NFVFRMRU1FTlRfUEVORElORxADEhcKE1JFQVNPTl9SQVRFX0xJTUlURUQQBBIcChhSRUFTT05fVFJBTlNJRU5UX0ZBSUxVUkUQBRIVChFSRUFTT05fU1RBVEVfV0FJVBAGEhoKFlJFQVNPTl9SRVRSWV9FWEhBVVNURUQQBxIXChNSRUFTT05fUVVFVUVfRkFJTEVEEAgSGAoUUkVBU09OX0FDQ0VTU19ERU5JRUQQCRIZChVSRUFTT05fUVVPVEFfRVhDRUVERUQQChIYChRSRUFTT05fQVRURU1QVF9MSU1JVBALEhoKFlJFQVNPTl9QT0xJQ1lfRElTQUJMRUQQDBIXChNSRUFTT05fTk9UX0VOUk9MTEVEEA0SHgoaUkVBU09OX1NUQUxFX0NPTkZJR1VSQVRJT04QDhIgChxSRUFTT05fTk9fQVVUSE9SSVpFRF9BQ1RJT05TEA8SGwoXUkVBU09OX0JMT0NLRVJfTUlTTUFUQ0gQEBIUChBSRUFTT05fQ0FOQ0VMTEVEEBESGQoVUkVBU09OX0lOVEVSTkFMX0VSUk9SEBISIwofUkVBU09OX0NVU1RPTV9BR0VOVF9VTkFWQUlMQUJMRRATIlwKBkFjdGlvbhISCg5BQ1RJT05fVU5LTk9XThAAEgoKBkZJWF9DSRABEhsKF0FERFJFU1NfUkVWSUVXX0NPTU1FTlRTEAISFQoRUkVTT0xWRV9DT05GTElDVFMQAyJtCgtEZWx0YVJlYXNvbhIRCg1ERUxUQV9VTktOT1dOEAASEAoMQUNUSU9OX0FEREVEEAESEQoNSEVBRF9BRFZBTkNFRBACEhEKDUJBU0VfQURWQU5DRUQQAxITCg9DT05URVhUX0NIQU5HRUQQBCK3AQoeQWdlbnRNZXJnZUFjdGl2aXR5Tm90aWZpY2F0aW9uEjoKBXNjb3BlGAEgASgLMisuZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZVNjb3BlEkAKCGFjdGl2aXR5GAIgASgLMi4uZ2l0aHViLmNvcGlsb3Rfc2Vzc2lvbnMudjEuQWdlbnRNZXJnZUFjdGl2aXR5EhcKD3Nlc3Npb25fY2hhbmdlZBgDIAEoCGIGcHJvdG8z", [file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeScope
 */
export type AgentMergeScope = Message<"github.copilot_sessions.v1.AgentMergeScope"> & {
  /**
   * @generated from field: string namespace = 1;
   */
  namespace: string;

  /**
   * @generated from field: int64 repository_id = 2;
   */
  repositoryId: bigint;

  /**
   * @generated from field: int64 pull_request_number = 3;
   */
  pullRequestNumber: bigint;

  /**
   * @generated from field: int64 pull_request_id = 4;
   */
  pullRequestId: bigint;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeScope.
 * Use `create(AgentMergeScopeSchema)` to create a new message.
 */
export const AgentMergeScopeSchema: GenMessage<AgentMergeScope> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 0);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeContext
 */
export type AgentMergeContext = Message<"github.copilot_sessions.v1.AgentMergeContext"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeScope scope = 1;
   */
  scope?: AgentMergeScope;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;

  /**
   * @generated from field: google.protobuf.UInt64Value configuration_generation = 3;
   */
  configurationGeneration?: bigint;

  /**
   * @generated from field: string head_oid = 4;
   */
  headOid: string;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeContext.DisabledReason disabled_reason = 5;
   */
  disabledReason: AgentMergeContext_DisabledReason;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeContext.
 * Use `create(AgentMergeContextSchema)` to create a new message.
 */
export const AgentMergeContextSchema: GenMessage<AgentMergeContext> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 1);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeContext.DisabledReason
 */
export enum AgentMergeContext_DisabledReason {
  /**
   * @generated from enum value: DISABLED_REASON_NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: DISABLED_REASON_ATTEMPT_LIMIT = 1;
   */
  ATTEMPT_LIMIT = 1,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeContext.DisabledReason.
 */
export const AgentMergeContext_DisabledReasonSchema: GenEnum<AgentMergeContext_DisabledReason> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 1, 0);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeSession
 */
export type AgentMergeSession = Message<"github.copilot_sessions.v1.AgentMergeSession"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string goal = 3;
   */
  goal: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeSession.Status status = 5;
   */
  status: AgentMergeSession_Status;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeSession.LifecycleSource lifecycle_source = 6;
   */
  lifecycleSource: AgentMergeSession_LifecycleSource;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeSession.
 * Use `create(AgentMergeSessionSchema)` to create a new message.
 */
export const AgentMergeSessionSchema: GenMessage<AgentMergeSession> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 2);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeSession.Status
 */
export enum AgentMergeSession_Status {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: QUEUED = 2;
   */
  QUEUED = 2,

  /**
   * @generated from enum value: RUNNING = 3;
   */
  RUNNING = 3,

  /**
   * @generated from enum value: COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * @generated from enum value: FAILED = 5;
   */
  FAILED = 5,

  /**
   * @generated from enum value: CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * @generated from enum value: TIMED_OUT = 7;
   */
  TIMED_OUT = 7,

  /**
   * @generated from enum value: WAITING_FOR_USER = 8;
   */
  WAITING_FOR_USER = 8,

  /**
   * @generated from enum value: IDLE = 9;
   */
  IDLE = 9,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeSession.Status.
 */
export const AgentMergeSession_StatusSchema: GenEnum<AgentMergeSession_Status> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 2, 0);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeSession.LifecycleSource
 */
export enum AgentMergeSession_LifecycleSource {
  /**
   * @generated from enum value: JOB = 0;
   */
  JOB = 0,

  /**
   * @generated from enum value: AHP_SESSION = 1;
   */
  AHP_SESSION = 1,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeSession.LifecycleSource.
 */
export const AgentMergeSession_LifecycleSourceSchema: GenEnum<AgentMergeSession_LifecycleSource> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 2, 1);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeStatusResponse
 */
export type AgentMergeStatusResponse = Message<"github.copilot_sessions.v1.AgentMergeStatusResponse"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeContext context = 1;
   */
  context?: AgentMergeContext;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeStatusResponse.Selection selection = 2;
   */
  selection: AgentMergeStatusResponse_Selection;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeSession selected_session = 3;
   */
  selectedSession?: AgentMergeSession;

  /**
   * @generated from field: string activity_channel = 4;
   */
  activityChannel: string;

  /**
   * @generated from field: repeated string terminal_job_ids = 5;
   */
  terminalJobIds: string[];

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationStatus evaluation_status = 6;
   */
  evaluationStatus?: AgentMergeEvaluationStatus;

  /**
   * Content-free CMC status invalidations on the signed PR database-ID channel.
   *
   * @generated from field: string evaluation_status_channel = 7;
   */
  evaluationStatusChannel: string;

  /**
   * The only primary presentation for the persistent-status consumer.
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergeResolvedStatus resolved_status = 8;
   */
  resolvedStatus?: AgentMergeResolvedStatus;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeStatusResponse.
 * Use `create(AgentMergeStatusResponseSchema)` to create a new message.
 */
export const AgentMergeStatusResponseSchema: GenMessage<AgentMergeStatusResponse> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 3);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeStatusResponse.Selection
 */
export enum AgentMergeStatusResponse_Selection {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: SELECTED = 2;
   */
  SELECTED = 2,

  /**
   * @generated from enum value: UNAVAILABLE = 3;
   */
  UNAVAILABLE = 3,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeStatusResponse.Selection.
 */
export const AgentMergeStatusResponse_SelectionSchema: GenEnum<AgentMergeStatusResponse_Selection> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 3, 0);

/**
 * Display-only status. Enrollment and accepted sessions remain authoritative.
 * Codes are producer-owned strings, not a consumer reason enum.
 *
 * @generated from message github.copilot_sessions.v1.AgentMergePresentation
 */
export type AgentMergePresentation = Message<"github.copilot_sessions.v1.AgentMergePresentation"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergePresentation.Kind kind = 1;
   */
  kind: AgentMergePresentation_Kind;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * Plain text only, never HTML or Markdown.
   *
   * @generated from field: string message = 3;
   */
  message: string;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergePresentation.
 * Use `create(AgentMergePresentationSchema)` to create a new message.
 */
export const AgentMergePresentationSchema: GenMessage<AgentMergePresentation> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 4);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergePresentation.Kind
 */
export enum AgentMergePresentation_Kind {
  /**
   * @generated from enum value: KIND_UNKNOWN = 0;
   */
  KIND_UNKNOWN = 0,

  /**
   * @generated from enum value: NEUTRAL = 1;
   */
  NEUTRAL = 1,

  /**
   * @generated from enum value: SUCCESS = 2;
   */
  SUCCESS = 2,

  /**
   * @generated from enum value: WARNING = 3;
   */
  WARNING = 3,

  /**
   * @generated from enum value: CRITICAL = 4;
   */
  CRITICAL = 4,

  /**
   * @generated from enum value: BUSY = 5;
   */
  BUSY = 5,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergePresentation.Kind.
 */
export const AgentMergePresentation_KindSchema: GenEnum<AgentMergePresentation_Kind> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 4, 0);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeEvaluationScope
 */
export type AgentMergeEvaluationScope = Message<"github.copilot_sessions.v1.AgentMergeEvaluationScope"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeScope scope = 1;
   */
  scope?: AgentMergeScope;

  /**
   * @generated from field: string repository_owner_id = 2;
   */
  repositoryOwnerId: string;

  /**
   * @generated from field: string repository_owner_type = 3;
   */
  repositoryOwnerType: string;

  /**
   * @generated from field: string owner_user_id = 4;
   */
  ownerUserId: string;

  /**
   * @generated from field: string configuration_generation = 5;
   */
  configurationGeneration: string;

  /**
   * Empty when the live head is unknown; never replace with the stored tip.
   *
   * @generated from field: string head_oid = 6;
   */
  headOid: string;

  /**
   * Empty only when no authoritative current base is available.
   *
   * @generated from field: string base_oid = 7;
   */
  baseOid: string;

  /**
   * Published CMC enrollment generation used as the display-cycle identity.
   *
   * @generated from field: string display_generation = 8;
   */
  displayGeneration: string;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeEvaluationScope.
 * Use `create(AgentMergeEvaluationScopeSchema)` to create a new message.
 */
export const AgentMergeEvaluationScopeSchema: GenMessage<AgentMergeEvaluationScope> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 5);

/**
 * One complete CMC presentation for this read, without work history.
 *
 * @generated from message github.copilot_sessions.v1.AgentMergeResolvedStatus
 */
export type AgentMergeResolvedStatus = Message<"github.copilot_sessions.v1.AgentMergeResolvedStatus"> & {
  /**
   * @generated from field: bool visible = 1;
   */
  visible: boolean;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationScope scope = 3;
   */
  scope?: AgentMergeEvaluationScope;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergePresentation presentation = 7;
   */
  presentation?: AgentMergePresentation;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeResolvedSession session = 9;
   */
  session?: AgentMergeResolvedSession;

  /**
   * Busy or reversible progress uses this absolute deadline and a fallback.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 10;
   */
  expiresAt?: Timestamp;

  /**
   * Nonbusy fallback for the absolute deadline, never a lease renewal.
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergePresentation expired_presentation = 11;
   */
  expiredPresentation?: AgentMergePresentation;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeResolvedStatus.
 * Use `create(AgentMergeResolvedStatusSchema)` to create a new message.
 */
export const AgentMergeResolvedStatusSchema: GenMessage<AgentMergeResolvedStatus> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 6);

/**
 * Only this response's viewer-authorized session details.
 *
 * @generated from message github.copilot_sessions.v1.AgentMergeResolvedSession
 */
export type AgentMergeResolvedSession = Message<"github.copilot_sessions.v1.AgentMergeResolvedSession"> & {
  /**
   * @generated from field: string job_id = 1;
   */
  jobId: string;

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId: string;

  /**
   * @generated from field: string goal = 3;
   */
  goal: string;

  /**
   * @generated from field: string url = 4;
   */
  url: string;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeResolvedSession.
 * Use `create(AgentMergeResolvedSessionSchema)` to create a new message.
 */
export const AgentMergeResolvedSessionSchema: GenMessage<AgentMergeResolvedSession> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 7);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeEvaluationSnapshot
 */
export type AgentMergeEvaluationSnapshot = Message<"github.copilot_sessions.v1.AgentMergeEvaluationSnapshot"> & {
  /**
   * @generated from field: string revision = 1;
   */
  revision: string;

  /**
   * @generated from field: string evaluation_revision = 2;
   */
  evaluationRevision: string;

  /**
   * @generated from field: string evaluation_id = 3;
   */
  evaluationId: string;

  /**
   * @generated from field: uint32 attempt = 4;
   */
  attempt: number;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationSnapshot.Phase phase = 5;
   */
  phase: AgentMergeEvaluationSnapshot_Phase;

  /**
   * @generated from field: google.protobuf.Timestamp observed_at = 6;
   */
  observedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 7;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeEvaluationSnapshot.
 * Use `create(AgentMergeEvaluationSnapshotSchema)` to create a new message.
 */
export const AgentMergeEvaluationSnapshotSchema: GenMessage<AgentMergeEvaluationSnapshot> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 8);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeEvaluationSnapshot.Phase
 */
export enum AgentMergeEvaluationSnapshot_Phase {
  /**
   * @generated from enum value: PHASE_UNKNOWN = 0;
   */
  PHASE_UNKNOWN = 0,

  /**
   * @generated from enum value: QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: EVALUATING = 2;
   */
  EVALUATING = 2,

  /**
   * @generated from enum value: PREPARING = 3;
   */
  PREPARING = 3,

  /**
   * @generated from enum value: DEFERRED = 4;
   */
  DEFERRED = 4,

  /**
   * @generated from enum value: FINISHED = 5;
   */
  FINISHED = 5,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeEvaluationSnapshot.Phase.
 */
export const AgentMergeEvaluationSnapshot_PhaseSchema: GenEnum<AgentMergeEvaluationSnapshot_Phase> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 8, 0);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeEvaluationStatus
 */
export type AgentMergeEvaluationStatus = Message<"github.copilot_sessions.v1.AgentMergeEvaluationStatus"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationStatus.Availability availability = 1;
   */
  availability: AgentMergeEvaluationStatus_Availability;

  /**
   * Current authorized scope, including when the snapshot is absent.
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationScope scope = 2;
   */
  scope?: AgentMergeEvaluationScope;

  /**
   * Durable read cursor. Decimal strings must never become JavaScript numbers.
   *
   * @generated from field: string revision = 3;
   */
  revision: string;

  /**
   * Absence clears older observations; it never means "nothing to do".
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergeEvaluationSnapshot snapshot = 4;
   */
  snapshot?: AgentMergeEvaluationSnapshot;

  /**
   * A validated producer presentation, or a backend-owned generic fallback.
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergePresentation presentation = 5;
   */
  presentation?: AgentMergePresentation;

  /**
   * Use after local lease expiry while refetching; never retain an old spinner.
   *
   * @generated from field: github.copilot_sessions.v1.AgentMergePresentation fallback_presentation = 6;
   */
  fallbackPresentation?: AgentMergePresentation;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeEvaluationStatus.
 * Use `create(AgentMergeEvaluationStatusSchema)` to create a new message.
 */
export const AgentMergeEvaluationStatusSchema: GenMessage<AgentMergeEvaluationStatus> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 9);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeEvaluationStatus.Availability
 */
export enum AgentMergeEvaluationStatus_Availability {
  /**
   * @generated from enum value: AVAILABILITY_UNKNOWN = 0;
   */
  AVAILABILITY_UNKNOWN = 0,

  /**
   * @generated from enum value: AVAILABLE = 1;
   */
  AVAILABLE = 1,

  /**
   * @generated from enum value: UNAVAILABLE = 2;
   */
  UNAVAILABLE = 2,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeEvaluationStatus.Availability.
 */
export const AgentMergeEvaluationStatus_AvailabilitySchema: GenEnum<AgentMergeEvaluationStatus_Availability> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 9, 0);

/**
 * Enum identities match sweagentd.v1.AgentMergeActivityUpdated.
 * This allowlisted browser contract never includes prompts or raw errors.
 *
 * @generated from message github.copilot_sessions.v1.AgentMergeActivity
 */
export type AgentMergeActivity = Message<"github.copilot_sessions.v1.AgentMergeActivity"> & {
  /**
   * @generated from field: string transport_scope = 1;
   */
  transportScope: string;

  /**
   * @generated from field: string evaluation_id = 2;
   */
  evaluationId: string;

  /**
   * @generated from field: int32 attempt = 3;
   */
  attempt: number;

  /**
   * @generated from field: string transition_id = 4;
   */
  transitionId: string;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeActivity.Phase phase = 5;
   */
  phase: AgentMergeActivity_Phase;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeActivity.Outcome outcome = 6;
   */
  outcome: AgentMergeActivity_Outcome;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeActivity.Reason reason = 7;
   */
  reason: AgentMergeActivity_Reason;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 8;
   */
  occurredAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 9;
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp triggered_at = 10;
   */
  triggeredAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp retry_at = 11;
   */
  retryAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Int64Value advisory_configuration_generation = 12;
   */
  advisoryConfigurationGeneration?: bigint;

  /**
   * @generated from field: google.protobuf.Int64Value current_configuration_generation = 13;
   */
  currentConfigurationGeneration?: bigint;

  /**
   * @generated from field: google.protobuf.StringValue head_oid = 14;
   */
  headOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue base_oid = 15;
   */
  baseOid?: string;

  /**
   * @generated from field: google.protobuf.StringValue job_id = 16;
   */
  jobId?: string;

  /**
   * @generated from field: google.protobuf.StringValue session_id = 17;
   */
  sessionId?: string;

  /**
   * @generated from field: google.protobuf.StringValue assignment_id = 18;
   */
  assignmentId?: string;

  /**
   * @generated from field: repeated github.copilot_sessions.v1.AgentMergeActivity.Action authorized_actions = 19;
   */
  authorizedActions: AgentMergeActivity_Action[];

  /**
   * @generated from field: google.protobuf.StringValue steering_command_id = 20;
   */
  steeringCommandId?: string;

  /**
   * @generated from field: repeated github.copilot_sessions.v1.AgentMergeActivity.DeltaReason delta_reasons = 21;
   */
  deltaReasons: AgentMergeActivity_DeltaReason[];

  /**
   * @generated from field: repeated github.copilot_sessions.v1.AgentMergeActivity.Action delta_actions = 22;
   */
  deltaActions: AgentMergeActivity_Action[];
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeActivity.
 * Use `create(AgentMergeActivitySchema)` to create a new message.
 */
export const AgentMergeActivitySchema: GenMessage<AgentMergeActivity> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 10);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeActivity.Phase
 */
export enum AgentMergeActivity_Phase {
  /**
   * @generated from enum value: PHASE_UNKNOWN = 0;
   */
  PHASE_UNKNOWN = 0,

  /**
   * @generated from enum value: EVALUATION_QUEUED = 1;
   */
  EVALUATION_QUEUED = 1,

  /**
   * @generated from enum value: EVALUATING = 2;
   */
  EVALUATING = 2,

  /**
   * @generated from enum value: PREPARING_SESSION = 3;
   */
  PREPARING_SESSION = 3,

  /**
   * @generated from enum value: DEFERRED = 4;
   */
  DEFERRED = 4,

  /**
   * @generated from enum value: EVALUATION_FINISHED = 5;
   */
  EVALUATION_FINISHED = 5,

  /**
   * @generated from enum value: STEERING_ACCEPTED = 6;
   */
  STEERING_ACCEPTED = 6,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeActivity.Phase.
 */
export const AgentMergeActivity_PhaseSchema: GenEnum<AgentMergeActivity_Phase> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 10, 0);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeActivity.Outcome
 */
export enum AgentMergeActivity_Outcome {
  /**
   * @generated from enum value: OUTCOME_UNKNOWN = 0;
   */
  OUTCOME_UNKNOWN = 0,

  /**
   * @generated from enum value: NO_ACTION = 1;
   */
  NO_ACTION = 1,

  /**
   * @generated from enum value: WAITING = 2;
   */
  WAITING = 2,

  /**
   * @generated from enum value: BLOCKED = 3;
   */
  BLOCKED = 3,

  /**
   * @generated from enum value: JOB_CREATED = 4;
   */
  JOB_CREATED = 4,

  /**
   * @generated from enum value: JOB_REUSED = 5;
   */
  JOB_REUSED = 5,

  /**
   * @generated from enum value: STEERED = 6;
   */
  STEERED = 6,

  /**
   * @generated from enum value: FAILED = 7;
   */
  FAILED = 7,

  /**
   * @generated from enum value: CANCELLED = 8;
   */
  CANCELLED = 8,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeActivity.Outcome.
 */
export const AgentMergeActivity_OutcomeSchema: GenEnum<AgentMergeActivity_Outcome> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 10, 1);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeActivity.Reason
 */
export enum AgentMergeActivity_Reason {
  /**
   * @generated from enum value: REASON_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: REASON_CHECKS_PENDING = 1;
   */
  CHECKS_PENDING = 1,

  /**
   * @generated from enum value: REASON_MERGEABILITY_PENDING = 2;
   */
  MERGEABILITY_PENDING = 2,

  /**
   * @generated from enum value: REASON_SETTLEMENT_PENDING = 3;
   */
  SETTLEMENT_PENDING = 3,

  /**
   * @generated from enum value: REASON_RATE_LIMITED = 4;
   */
  RATE_LIMITED = 4,

  /**
   * @generated from enum value: REASON_TRANSIENT_FAILURE = 5;
   */
  TRANSIENT_FAILURE = 5,

  /**
   * @generated from enum value: REASON_STATE_WAIT = 6;
   */
  STATE_WAIT = 6,

  /**
   * @generated from enum value: REASON_RETRY_EXHAUSTED = 7;
   */
  RETRY_EXHAUSTED = 7,

  /**
   * @generated from enum value: REASON_QUEUE_FAILED = 8;
   */
  QUEUE_FAILED = 8,

  /**
   * @generated from enum value: REASON_ACCESS_DENIED = 9;
   */
  ACCESS_DENIED = 9,

  /**
   * @generated from enum value: REASON_QUOTA_EXCEEDED = 10;
   */
  QUOTA_EXCEEDED = 10,

  /**
   * @generated from enum value: REASON_ATTEMPT_LIMIT = 11;
   */
  ATTEMPT_LIMIT = 11,

  /**
   * @generated from enum value: REASON_POLICY_DISABLED = 12;
   */
  POLICY_DISABLED = 12,

  /**
   * @generated from enum value: REASON_NOT_ENROLLED = 13;
   */
  NOT_ENROLLED = 13,

  /**
   * @generated from enum value: REASON_STALE_CONFIGURATION = 14;
   */
  STALE_CONFIGURATION = 14,

  /**
   * @generated from enum value: REASON_NO_AUTHORIZED_ACTIONS = 15;
   */
  NO_AUTHORIZED_ACTIONS = 15,

  /**
   * @generated from enum value: REASON_BLOCKER_MISMATCH = 16;
   */
  BLOCKER_MISMATCH = 16,

  /**
   * @generated from enum value: REASON_CANCELLED = 17;
   */
  CANCELLED = 17,

  /**
   * @generated from enum value: REASON_INTERNAL_ERROR = 18;
   */
  INTERNAL_ERROR = 18,

  /**
   * @generated from enum value: REASON_CUSTOM_AGENT_UNAVAILABLE = 19;
   */
  CUSTOM_AGENT_UNAVAILABLE = 19,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeActivity.Reason.
 */
export const AgentMergeActivity_ReasonSchema: GenEnum<AgentMergeActivity_Reason> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 10, 2);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeActivity.Action
 */
export enum AgentMergeActivity_Action {
  /**
   * @generated from enum value: ACTION_UNKNOWN = 0;
   */
  ACTION_UNKNOWN = 0,

  /**
   * @generated from enum value: FIX_CI = 1;
   */
  FIX_CI = 1,

  /**
   * @generated from enum value: ADDRESS_REVIEW_COMMENTS = 2;
   */
  ADDRESS_REVIEW_COMMENTS = 2,

  /**
   * @generated from enum value: RESOLVE_CONFLICTS = 3;
   */
  RESOLVE_CONFLICTS = 3,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeActivity.Action.
 */
export const AgentMergeActivity_ActionSchema: GenEnum<AgentMergeActivity_Action> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 10, 3);

/**
 * @generated from enum github.copilot_sessions.v1.AgentMergeActivity.DeltaReason
 */
export enum AgentMergeActivity_DeltaReason {
  /**
   * @generated from enum value: DELTA_UNKNOWN = 0;
   */
  DELTA_UNKNOWN = 0,

  /**
   * @generated from enum value: ACTION_ADDED = 1;
   */
  ACTION_ADDED = 1,

  /**
   * @generated from enum value: HEAD_ADVANCED = 2;
   */
  HEAD_ADVANCED = 2,

  /**
   * @generated from enum value: BASE_ADVANCED = 3;
   */
  BASE_ADVANCED = 3,

  /**
   * @generated from enum value: CONTEXT_CHANGED = 4;
   */
  CONTEXT_CHANGED = 4,
}

/**
 * Describes the enum github.copilot_sessions.v1.AgentMergeActivity.DeltaReason.
 */
export const AgentMergeActivity_DeltaReasonSchema: GenEnum<AgentMergeActivity_DeltaReason> = /*@__PURE__*/
  enumDesc(file_copilot_sessions_v1_agent_merge, 10, 4);

/**
 * @generated from message github.copilot_sessions.v1.AgentMergeActivityNotification
 */
export type AgentMergeActivityNotification = Message<"github.copilot_sessions.v1.AgentMergeActivityNotification"> & {
  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeScope scope = 1;
   */
  scope?: AgentMergeScope;

  /**
   * @generated from field: github.copilot_sessions.v1.AgentMergeActivity activity = 2;
   */
  activity?: AgentMergeActivity;

  /**
   * @generated from field: bool session_changed = 3;
   */
  sessionChanged: boolean;
};

/**
 * Describes the message github.copilot_sessions.v1.AgentMergeActivityNotification.
 * Use `create(AgentMergeActivityNotificationSchema)` to create a new message.
 */
export const AgentMergeActivityNotificationSchema: GenMessage<AgentMergeActivityNotification> = /*@__PURE__*/
  messageDesc(file_copilot_sessions_v1_agent_merge, 11);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(AgentMergeScopeSchema, "464216302412")
registerSchemaHash(AgentMergeContextSchema, "ce05a4d5f449")
registerSchemaHash(AgentMergeSessionSchema, "1500175994c2")
registerSchemaHash(AgentMergeStatusResponseSchema, "63e13d3d36fc")
registerSchemaHash(AgentMergePresentationSchema, "168152997887")
registerSchemaHash(AgentMergeEvaluationScopeSchema, "69fd033e507a")
registerSchemaHash(AgentMergeResolvedStatusSchema, "f3789e6aba4a")
registerSchemaHash(AgentMergeResolvedSessionSchema, "f1b5998a2290")
registerSchemaHash(AgentMergeEvaluationSnapshotSchema, "1b2dcbd49a6e")
registerSchemaHash(AgentMergeEvaluationStatusSchema, "d26a5f430416")
registerSchemaHash(AgentMergeActivitySchema, "34340ed3faca")
registerSchemaHash(AgentMergeActivityNotificationSchema, "d816579af7b7")
